const BASE = process.env.REACT_APP_API_BASE_URL || ""

export class NotFoundError extends Error {}

const handle = async (response) => {
  const body = await response.json().catch(() => null)
  if (response.status === 404) {
    throw new NotFoundError(body?.error || "not_found")
  }
  if (!response.ok) {
    throw new Error(body?.error || `Request failed: ${response.status}`)
  }
  return body
}

const jsonHeaders = { "Content-Type": "application/json" }

export const listGyms = () => fetch(`${BASE}/api/gyms`).then(handle)

export const fetchGym = (slug) => fetch(`${BASE}/api/gyms/${slug}`).then(handle)

export const createGym = (slug, name) =>
  fetch(`${BASE}/api/gyms`, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ slug, name }),
  }).then(handle)

export const setGymSlot = (slug, slot, body) =>
  fetch(`${BASE}/api/gyms/${slug}/slots/${slot}`, {
    method: "PUT",
    headers: jsonHeaders,
    body: JSON.stringify(body),
  }).then(handle)

export const clearGymSlot = (slug, slot) =>
  fetch(`${BASE}/api/gyms/${slug}/slots/${slot}`, {
    method: "DELETE",
  }).then(handle)

// Set a slot, creating the gym first if it doesn't exist yet (the caller
// has already named the gym deliberately, e.g. via the slot picker dialog).
export const displayAtGym = async (slug, slot, body) => {
  try {
    return await setGymSlot(slug, slot, body)
  } catch (error) {
    if (error instanceof NotFoundError && error.message === "gym_not_found") {
      await createGym(slug, slug)
      return setGymSlot(slug, slot, body)
    }
    throw error
  }
}

export const normalizeSlug = (text) =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
